import { render, staticRenderFns } from "./route.vue?vue&type=template&id=b94d4d28&scoped=true"
import script from "./route.vue?vue&type=script&lang=js"
export * from "./route.vue?vue&type=script&lang=js"
import style0 from "./route.vue?vue&type=style&index=0&id=b94d4d28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94d4d28",
  null
  
)

export default component.exports